module.exports = {
      id: "twitter-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.05c569e2.svg#twitter-usage",
      toString: function () {
        return this.url;
      }
    }